import { type ComponentType } from 'react';
import { Button } from './Button';

interface EmptyStateProps {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ icon: Icon, title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Icon className="mb-4 h-12 w-12 text-gray-300 dark:text-gray-600" />
      <h3 className="mb-1 text-base font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
      {description && <p className="mb-4 max-w-sm text-sm text-gray-500 dark:text-gray-400">{description}</p>}
      {actionLabel && onAction && (
        <Button variant="primary" size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
